const XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const HTML = 'text/html';
const ERROR_TYPE = 'errorType';

const FILE_TYPES = {
	XLSX,
	DOCX,
	HTML,
	ERROR_TYPE,
};

export default FILE_TYPES;
